// extracted by mini-css-extract-plugin
export default {"content-landing-pages-breadcrumbs":"YqS0OwK","contentLandingPagesBreadcrumbs":"YqS0OwK"};